<template class="template-project-lines">
    <div class="project-lines">
        <a-spin v-if="ifshowLoading" style="position:absolute;left:50%;top:45%"/>
        <div class="new-point">
            <div style="color:#505050;height:60px;line-height:60px;padding:0 24px;text-align:left;font-size:16px;">
                <a-icon style="color:#ccc" type="profile" />
                <span style="margin-left:4px;color:#aaa">项目节点</span>
            </div>
            <ul>
                <li :title='item.name' :class="{'active':index==selectedIndex}" v-for="(item, index) in nodeList" :key="index" @click="selectCurrentItem(item,index)">         
                    <span>{{item.name.length>10?(item.name).substring(0,10)+'...':item.name}}</span>
                </li>
                <li title='查看全部' @click="selectCurrentItem(viewAll,-1)" :class="{'active':selectedIndex==-1}">
                    <span>查看全部</span>
                </li>
            </ul>
        </div>
        <div class="content" :class="{'active':ifShowDetail}">
            <div class="title">
                <span>台词内容：</span>
                <a-input-search
                    style="width:50%"
                    v-model="content"
                    placeholder="请输入查询内容" @search="queryLinesList" />
                <a-button class="out-btn" @click="exportFile">导出</a-button>
            </div>
            <div class="area">
                <draggable v-model="lineList"  @start="isDragging=true" @end="isDragging=false">
                    <transition-group type="transition" :name="'flip-list'" tag="ul" class="list-group">
                        <div :class="{'active':index==selectCurrentIndex}" style="margin-top:16px" v-for="(item, index) in lineList" :key="index" @click="selectCurrentNode(item,index)">                     
                            <div class="list" >
                                <div class="operation">
                                    <span>{{item.nodeName}}</span>
                                    <div class="right operation-list">
                                        <a-icon type="delete" @click="confirm(item.id)" />
                                    </div>
                                </div>
                                <div class="area-edit">
                                    <span class="serial-number">{{index+1}}</span>
                                    <a-textarea style="line-height:20px;height:65px;resize:none;color:rgba(80, 80, 80, 1);font-size:14px" v-model='item.content' @blur="changeContent(item)" />
                                </div>
                                <div class="btn-list">
                                    <div>
                                        <a-icon @click="showModal('tryListen',item)" type="play-circle" />
                                        <span>试听</span>
                                        <a-icon @click="showModal('upLoad',item)" type="cloud-upload" />
                                        <span>上传</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </transition-group>
                </draggable> 
                <a-pagination style="margin-top:2px;float:right" @change="onChange" v-model="current" :total='total' />
            </div>
        </div>
        <a-icon v-if="!ifShowDetail" type="left-circle" style="position:fixed;right:5px;top:50%;color:rgba(204, 204, 204, 1);font-size:24px" @click="openDetail"/>
        <div class="detail" v-if="ifShowDetail">
            <a-icon v-if="ifShowDetail" type="right-circle" style="position:absolute;left:-12px;top:45%;color:rgba(204, 204, 204, 1);font-size:24px" @click="closeDetail"/>
            <div class="title" style="padding-bottom:12px;margin-bottom:24px;border-bottom:1px solid rgba(240, 240, 240, 1)">版本管理</div>
            <div class="current-edition">
                <div style="color:rgba(80, 80, 80, 1);font-size:14px;">当前台词版本：</div>
                <div>{{currentVersionName}}</div>
            </div>
            <div class="switch-edition">
                <span>切换当前台词版本：</span>
                <!-- <span>(数量{{versionCount}})</span> -->
            </div>
            <div class="select-edition">
                <a-select :defaultValue='currentVersionId' :key='currentVersionId' style="width: 90%" @change="(e)=>changeVersion(e)">
                    <a-select-option :title="item.name" :value='item.id' v-for="(item, index) in versionList" :key="index">{{item.name}}</a-select-option>
                </a-select>
                <div class="content-list">
                    <div class="voice">
                        <a-icon @click="showModal('versionVoice',1)" type="play-circle" />
                        <span>试听</span>
                    </div>
                    <div class="voice-content">{{currentContent}}</div>
                </div>
                <div class="remark-title">版本备注：</div>
                <a-textarea v-model="description" class="remark-content" placeholder="请输入内容" :rows="4" />
                <div class="application">
                    <a-button @click="saveVersion">应用</a-button>
                </div>
            </div>
        </div>
        <a-modal
            :mask-closable="true"
            :title="modalTitle"
            :visible="visible"
            @ok="handleOk"
            @cancel="handleCancel"
            okText="确认" cancelText="取消"
            >
            <div v-if="modalTitle=='试听'">
                <div v-if="voiceUrl!=''">
                    <audio controls autoplay :src="voiceUrl"></audio>
                </div>
                <div v-if="voiceUrl==''">
                    这段台词没有录音文件，请上传
                </div>
            </div>
            <div v-if="modalTitle=='上传'">
                <div :key='randomNum'>
                    <a-upload
                        name="file"
                        :multiple="false"
                        :customRequest="customRequest"
                        @change="onUpload"
                        ref="pathClear"
                    >
                        <a-button type="primary"> 
                            <a-icon type="upload" />导入录音文件
                        </a-button>
                    </a-upload>
                </div>
            </div>
        </a-modal>
    </div>
</template>

<script>
import draggable from "vuedraggable";
export default {
    name: 'ProjectLines',
    props: {
        msg: String
    },
    components: {
      draggable
    },
    data() {
        return {
            isDragging: false,
            delayedDragging: false,
            projectId: '',
            nodeList: [],
            current: 1,
            size: 10,
            content: '',
            nodeId: '',
            lineList: [],
            total: 0,
            versionCount: 0,
            currentVersionName: '',
            description: '',
            currentVersionId: '',
            ifShowDetail: false,
            selectedIndex: 0,
            selectCurrentIndex: null,
            versionList: [],
            currentContent: '',
            selectObj: {},
            talkingSkillId: '',
            selectVersionId: '',
            visible: false,
            modalTitle: '',
            voiceUrl: '',
            fileList: [],
            uploading: false,
            newFormData: '',
            versionVoiceUrl: '',
            viewAll: {
                id: ''
            },
            ifshowLoading: false,
            randomNum: 1,
            currentNodeId: '',
        };
    },
    methods: {
        changeVersion(value) {
            this.currentContent = this.selectObj[value].content
            this.description = this.selectObj[value].description
            this.selectVersionId = this.selectObj[value].id
            this.versionVoiceUrl = this.selectObj[value].voiceUrl==undefined?"":this.selectObj[value].voiceUrl
        },
        selectCurrentItem(item,index) {
            this.ifshowLoading = true
            this.nodeId = item.id
            this.current = 1
            this.selectedIndex = index
            this.ifShowDetail = false
            this.queryLinesList()
        },
        queryLinesList() {
            this.axios( 
                {
                    method:'get',
                    url:'/api/talkingSkill/list', 
                    params: {
                        current: this.current,
                        size: this.size,
                        content: this.content,
                        projectId: this.projectId,
                        nodeId: this.nodeId,
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.lineList = response.data.data.records
                    this.total = response.data.data.total
                }else{
                    // alert(response.data.message)
                    this.$message.error(response.data.message);
                }
                this.ifshowLoading = false
            })
            .catch(error=> {
                console.log(error)
            })
        },
        queryNodeData() {
            this.axios( 
                {
                    method:'get',
                    url:'/api/dropdown/node', 
                    params: {
                        projectId: this.projectId
                    }
                }
            )
            .then(response=> {
                if(response.data.code == 0){
                    this.nodeList = response.data.data
                    if(this.nodeList.length > 0){
                        this.nodeId = this.nodeList[0]['id']
                        this.queryLinesList()
                    }
                }else{
                    // alert(response.data.message)
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        onChange(current) {
            this.current = current;
            this.queryLinesList()
        },
        selectCurrentNode(item,index) {
            this.currentNodeId = item.id
            this.versionCount = item.versionCount
            this.currentVersionName = item.currentVersionName
            this.currentVersionId = item.currentVersionId
            this.selectCurrentIndex = index
            this.versionList = item.versionList
            this.selectObj = {}
            this.talkingSkillId = item.id
            this.versionVoiceUrl = item.voiceUrl
            for(let i = 0; i < item.versionList.length; i++){
                if(item.versionList[i].id == item.currentVersionId){
                    this.description = item.versionList[i].description
                    this.currentContent = item.versionList[i].content
                    this.selectVersionId = item.versionList[i].id
                }
                this.selectObj[item.versionList[i].id] = item.versionList[i]
            }
        },
        saveVersion() {
            this.axios.post('/api/talkingSkill/version', {
                talkingSkillId: this.talkingSkillId,
                versionId: this.selectVersionId,
                content: this.description
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.queryLinesList()
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        getLength(str) {
            let realLength = 0, len = str.length, charCode = -1;
            for (let i = 0; i < len; i++) {
                charCode = str.charCodeAt(i);
                if (charCode >= 0 && charCode <= 128) realLength += 1;
                else realLength += 2;
            }
            return realLength
        },
        changeContent(item) {
            let newContent = (item.content).replace(/\s/g,"");
            if(this.getLength(newContent) > 2000){
                this.$message.error('台词内容太多，无法解析。请删减');
            }else{
                this.axios.post('/api/talkingSkill', {
                    id: item.id,
                    content: newContent
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.queryLinesList()
                    }else{
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            }
        },
        reset() {
            this.content = ""
            this.current = 1
            this.queryLinesList()
        },
        exportFile() {
            this.axios( 
                {
                    method:'get',
                    url:'/api/talkingSkill/list/export', 
                    responseType: 'arraybuffer',
                    params: {
                        content: this.content,
                        projectId: this.projectId,
                        nodeId: this.nodeId,
                    }
                }
            )
            .then(response => {
                this.download(response.data)
            })
            .catch(error=> {
                console.log(error)
            }) 
        },
        download(data) {
            if (!data) {
                return
            }
            const url = window.URL.createObjectURL(new Blob([data]))
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download', '项目台词.csv')
            document.body.appendChild(link)
            link.click()
            URL.revokeObjectURL(link.href) // 释放URL 对象
            document.body.removeChild(link)
            link = null
        },
        customRequest(data) { // 上传提交
            this.newFormData = ''
            const formData = new FormData() 
            formData.append('file', data.file)
            formData.append('talkingSkillId', this.talkingSkillId)
            this.newFormData = formData
        },
        saveFile(formData) {
            this.axios({
                method: 'post',
                url: '/api/talkingSkill/voice/upload',
                headers:{
                    'Content-Type':'application/x-www-form-urlencoded'
                },
                data: formData
            }).then((response) => {
                if(response.data.code == 0){
                    this.visible = false
                    setTimeout(this.upLoadSuccess(), 500);
                }else{
                    this.$message.error(response.data.message);
                }
            }).catch(function (error) {
                console.log(error)
            })
        },
        handleOk() {
            if(this.modalTitle == "试听"){
                this.visible = false
            }else if(this.modalTitle == "上传"){
                this.saveFile(this.newFormData)
            }
        },
        upLoadSuccess() {
            this.ifShowDetail = false
            this.$message.success('操作成功');
            this.queryLinesList()
        },
        onUpload() {
            this.$refs.pathClear.value = ''
        },
        handleCancel() {
            this.visible = false
        },
        showModal(type, item) {
            this.randomNum ++
            switch(type){
                case 'tryListen':
                    if(item.id != this.currentNodeId){
                        return false
                    }else{
                        this.visible = true
                        this.modalTitle = "试听"
                        this.voiceUrl = item.voiceUrl + "&timestamp=" + this.getTimestamp()
                    }
                break;
                case 'upLoad':
                    if(item.id != this.currentNodeId){
                        return false
                    }else{
                        this.visible = true
                        this.modalTitle = "上传"
                    }
                break;
                case 'versionVoice':
                    this.modalTitle = "试听"
                    this.visible = true
                    this.voiceUrl = this.versionVoiceUrl + "&timestamp=" + this.getTimestamp()
                break;
            }
        },
        getTimestamp() {
            return (new Date()).getTime();
        },
        changeLinesOrder(num) {
            this.axios.post('/api/project/node/talkingSkill/orderNo', {
                projectId: this.projectId,
                nodeId: this.nodeId,
                talkingSkillId: this.talkingSkillId,
                orderNo: num
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.queryLinesList()
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        listenLinesChange() {
            if(this.talkingSkillId == ''){
                this.$message.error('请先选中台词');
                this.queryLinesList()
            }else{
                this.lineList.map((item,key)=>{
                    if(item.id == this.talkingSkillId){
                        this.changeLinesOrder(key+1)
                    }
                })
            }
        },
        confirm(id) {
            if(id != this.currentNodeId){
                return false
            }
            this.$confirm({
                title: '提示',
                content: '确认要删除吗？',
                okText: '确认',
                cancelText: '取消',
                icon: 'warning',
                onOk: ()=> {
                    this.removeNode(id)
                },
            })
        },
        removeNode(id) {
            this.axios.post('/api/talkingSkill/delete', {
                id: id,
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.queryLinesList()
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        closeDetail() {
            this.ifShowDetail = false
        },
        openDetail() {
            if(this.currentVersionId != ""){
                this.ifShowDetail = true 
            }
        }
    },
    // computed: {
    //   dragOptions() {
    //     return {
    //         animation: 0,
    //         group: "description",
    //         ghostClass: "ghost"
    //     };
    //   },
    // },
    watch: {
      isDragging(newValue) {
        if (newValue) {
            this.delayedDragging = true;

            return;
        }
        this.$nextTick(() => {
            this.delayedDragging = false;
            this.listenLinesChange()
        });
      }
    },
    mounted: function() {
        this.sessionData('set','contentNavItem','colors');
        this.projectId = this.$route.query.projectId
        this.queryNodeData()
    }
}
</script>

<style scoped  lang="less">
     .project-lines{
        position: relative;
        i{
            cursor: pointer;
        }
        i.move{
            cursor: move;
        }
        .right{
            float: right;
        }
        .left{
            float: left;
        }
        background: #F5F5F5;
        height: 100%;
        padding: 24px 0 24px 24px;
        .new-point{
            z-index: 100;
            width: 240px;
            height: 100%;
            position: fixed;
            left:64px;
            background-color: #fff;
            color: #fff;
            font-size: 14px;
            padding-bottom: 70px;
            overflow-y: auto;
            li{
                height: 48px;
                line-height: 48px;
                font-size: 14px;
                color: #505050;
                cursor: pointer;
                text-align: left;
                padding-left:24px;
            }
            li:hover{
                background: rgba(34, 215, 187, 0.1);
            }
            li.active{
                background: rgba(34, 215, 187, 0.1);
                color: rgba(34, 215, 187, 1);
            }
        }
        .content{
            height: 100%;
            padding: 0 24px 60px 240px;
            overflow-y: auto;
            .title{
                width: 100%;
                height: 82px;
                background: #fff;
                padding: 24px;
                input{
                    width: 232px;
                    height: 32px;
                    margin-left: 3px;
                    margin-right: 16px;
                }
                .voice-file{
                    margin-right: 3px;
                }
                .search-btn{
                    margin: 0 8px 0 15px;
                    background: rgba(0, 186, 173, 1);
                    color: #fff;
                    font-size: 14px;
                }
                .reset-btn{
                    color: rgba(80, 80, 80, 1);
                    font-size: 14px;
                }
                .out-btn{
                    float: right;
                    background: rgba(255, 141, 26, 1);
                    color: #fff !important;
                    width: 90px;
                    height:34px;
                    line-height:34px;
                    text-align: center;
                    background: rgba(34, 215, 187, 1);
                    color: #fff;
                    font-size: 14px;
                    border: none;
                }
            }
            .area{
                background: #F5F5F5;
                div.active{
                    border: 2px dotted #22d7bb;
                }
                .list-group-item {
                    transition: transform 2.5s;
                }
                .list{
                    background: #fff;
                    padding: 16px 24px;
                    border-radius: 4px;
                    min-height:178px;
                    .operation{
                        span:nth-child(1){
                            color: rgba(51, 51, 51, 1);
                            font-size:16px;
                            margin-left: 30px;
                        }
                        .operation-list{
                            display: none;
                            i{
                                margin-right: 15px;
                                font-size: 20px;
                                color: rgba(0,0,0,.65);
                            }
                            i:hover{
                                color: rgba(255, 141, 26, 1) !important;
                            }
                        }
                    }
                }
                .list:hover{
                    .operation-list{
                        display: inline-block;
                    }
                }
                .area-edit{
                    margin-top: 18px;
                    display: flex;
                    .serial-number{
                        display: inline-block;
                        width: 30px;
                        height: 30px;
                        line-height: 30px;
                        font-size: 12px;
                        color: rgba(80, 80, 80, 1);
                        float: left;
                    }
                    textarea{
                        // width: 80%;
                        resize:none;
                        flex: 1;
                    }
                }
                .btn-list{
                    width: 100%;
                    height: 20px;
                    text-align: right;
                    margin-top: 16px;
                    margin-right:16px;
                    div{
                        float: right;
                        i{
                            margin-right: 6px;
                            margin-left: 22px;
                            font-size: 20px;
                            color: rgba(34, 215, 187, 1);
                            float: left;
                            cursor: pointer;
                        }
                        span{
                            float: left;
                        }
                    }
                }
                .add-lines{
                    display: block;
                    margin: 32px auto;
                    border-color: rgba(0, 186, 173, 1);
                    width: 120px;
                    height: 32px;
                    line-height: 32px;
                    font-size: 14px;
                    color: rgba(56, 56, 56, 1);
                }
            }
        }
        .content.active{
            padding: 0 340px 60px 240px;
        }
        .detail{
            width: 320px;
            height: 100%;
            position: fixed;
            right: 0px;
            top: 52px;
            padding: 12px 24px;
            background: #fff;
            .title{
                color: rgba(80, 80, 80, 1);
                font-size: 18px;
                text-align: left;
            }
            .current-edition{
                font-size: 12px;
                color: rgba(204, 204, 204, 1);
                margin-top: 16px;
                padding-bottom: 16px;
                // border-bottom: 1px solid rgba(238, 238, 238, 1);
            }
            .switch-edition{
                font-size: 14px;
                margin-top: 20px;
                color: rgba(80, 80, 80, 1);
                span:nth-child(1){
                    margin-right: 8px;
                }
            }
            .select-edition{
                width: 100%;
                margin-top: 16px;
                .content-list{
                    width: 90%;
                    min-height: 240px;
                    overflow-y: auto;
                    background: rgba(240, 242, 243, 0.5);
                    .voice{
                        background: rgba(34, 215, 187, 1);
                        color: #fff;
                        height: 24px;
                        line-height: 24px;
                        margin-top: 6px;
                        i{
                            font-size: 20px;
                            margin: 2px 12px 0 2px;
                            float: left;
                        }
                        i:hover{
                            color: #2672FF;
                        }
                    }
                    .voice-content{
                        padding: 8px 14px;
                        color: rgba(80, 80, 80, 1);
                        font-size: 12px;
                    }
                }
                .remark-title{
                    font-size: 14px;
                    color: rgba(80, 80, 80, 1);
                    margin: 24px  0 8px;
                }
                .remark-content{
                    width: 90%;
                }
                .application{
                    width: 90%;
                    button{
                        display: block;
                        margin-top: 16px;
                        border-color: rgba(34, 215, 187, 1);
                        background: rgba(34, 215, 187, 1);
                        color: #fff !important;
                    }
                }
            }
        }
    }
</style>
